import MyFormItem from './formItem.vue';

MyFormItem.install = function(Vue){
  Vue.component('MyFormItem', MyFormItem);
};

export default MyFormItem;